export default "/react/logoSkorozvon-208055de.png";